const BASE_PATH = '/task/check'

export default {
  getUserTaskList: () => ({
    url: `${BASE_PATH}/user/mission`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/TaskSite.js